import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData({
        url: 'https://wt8.wenhua.com.cn/',
        title: 'WT8麦语言量化交易软件'
    }).then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0

        //网站title定制
        if(!document.title){
            let obj = {};
            res.forEach(item => {
                obj[item.keyname] = item.value;
            });
            document.title = obj['appShortName_11'] + obj['appFullName_11'] + ' - 经典量化交易软件 Since2011';
        }
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()